"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_ERROR_CODE = void 0;
exports.ALERT_ERROR_CODE = "AlertError";
//# sourceMappingURL=error-codes.js.map